import React from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router-dom";
import GuideWalk from "../GuideWalk";
import { useGuide } from "../../context/Guide/GuideContext";
import { moduleWalk } from "../../content/moduleWalks";
import { guidePlanHint } from "../../content/guidePlan";
import { i18n } from "../../translate/i18n";

const GuideDock = ({ plan }) => {
  const history = useHistory();
  const { session, closeGuide, minimizeGuide, restoreGuide } = useGuide();
  if (!session?.id) return null;
  const locale = (i18n.language || "es").slice(0, 2);
  const steps = moduleWalk(session.id, locale, plan);
  if (!steps.length) return null;
  return ReactDOM.createPortal(
    <GuideWalk
      key={`${session.id}:${session.startId || ""}`}
      mode="dock"
      open
      minimized={!!session.minimized}
      title={session.title}
      planHint={guidePlanHint(plan, session.id, locale)}
      steps={steps}
      startId={session.startId}
      closeLabel={i18n.t("gettingStarted.close")}
      minimizeLabel={i18n.t("gettingStarted.minimize")}
      openLabel={i18n.t("gettingStarted.open")}
      onClose={closeGuide}
      onMinimize={minimizeGuide}
      onRestore={restoreGuide}
      onOpen={session.to ? () => history.push(session.to) : null}
      onNavigate={(to) => history.push(to)}
    />,
    document.body
  );
};

export default GuideDock;
